
var s13getDoaminUrl=window.location.protocol+"//"+window.location.hostname;
var URL=document.URL;

window.S13AsyncInit = function(){
	var pageName="";
	if(URL.indexOf("login")!=-1)
{
	pageName="/pages/handle-login";

}
else if(URL.indexOf("register")!=-1)
{
	pageName="/pages/handle-register";

}
    SAS13Obj.init({siteid:2115540,buttonType:["regular","small"]},s13getDoaminUrl+pageName);
  };
(function(d){
	var js, id = 'socialannex-s13-core', ref = d.getElementsByTagName('script')[0];
	if (d.getElementById(id)) {
		return;
	}
	js = d.createElement('script'); js.id = id; js.async = true;
	js.src = "//cdn.socialannex.com/s13/v2/s13-main.min.js";
	ref.parentNode.insertBefore(js, ref);
}(document));